export const mergeService = {
    stats: {},
    colsInTable: null,
    init: function (rowToMerge, itemClassNameToMerge) {
        this.colsInTable = parseInt(rowToMerge.dataset.numberOfCols);
        const itemsInRow = rowToMerge.querySelectorAll(`.${itemClassNameToMerge}`);
        if (!itemsInRow.length) return;

        const obj = this.prepareObjectToMerge(itemsInRow);
        const sortedObj = this.sortMergedObject(this.mergeObjectArr(obj));
        const rowsToShow = this.prepareRowsObjectToShow(sortedObj);
        this.cleanRowToMerge(rowToMerge);
        this.showMergedObj(rowsToShow, rowToMerge);
        const singleColumns = rowToMerge.querySelectorAll('.singleColumn');
        if (!singleColumns.length) return;
        singleColumns.forEach(col => this.findFreeSlotForSingleColumn(col, rowToMerge));
        rowToMerge.querySelectorAll('.emptyColumn').forEach(col => col.parentElement.removeChild(col));

        this.addEmptyMissingColumns(rowToMerge);

        if (this.colsInTable === 2) {
            const emptyCols = rowToMerge.querySelectorAll('.emptyColumn');
            emptyCols.forEach((col, i) => {
                emptyCols.length > 1 && i === 0? col.parentElement.removeChild(col) : null;
            })
        }
    },
    prepareObjectToMerge: function (items) {
        if (!items.length) return;
        return Array.prototype.map.call(items, item => {
            return {
                id: item.dataset.itemId || item.dataset.bonusId,
                columnNumber: item.parentElement.dataset.columnNumber,
                elementHTML: item
            }
        })
    },
    mergeObjectArr: function (obj) {
        let newObjArr = [];
        obj.forEach(element => {
            newObjArr.map(item => item.id).indexOf(element.id);
            if (newObjArr.map(item => item.id).indexOf(element.id) === -1) {
                newObjArr.push(element);
            } else {
                newObjArr.find(e => {
                    if (e.id === element.id) {
                        e.columnNumber += `,${element.columnNumber}`;
                    }
                });
            }
        });

        newObjArr.map((item, i) => newObjArr[i].columnNumber = item.columnNumber.split(','));
        return newObjArr;
    },
    sortMergedObject: function (obj) {
        return obj.sort((a, b) => {
            if (a.columnNumber.length > b.columnNumber.length) return -1;
            if (a.columnNumber.length < b.columnNumber.length) return 1;
            return 0;
        });
    },
    prepareRowsObjectToShow: function (obj) {
        let rows = [];

        rows.push(this.createNewRow(0));
        obj.forEach(item => {
            let stopMerging = false;
            if (item.columnNumber.length === this.colsInTable) rows[rows.length - 1].elementsInRow.push(item);

            if (item.columnNumber.length < this.colsInTable) {
                rows.forEach(element => {
                    element.elementsInRow.forEach(col => {
                        if (col.columnNumber.every((el, i) => el === item.columnNumber[i])) {
                            stopMerging = true;
                            return rows[rows.length - 1].elementsInRow.push(item);
                        }
                    });
                });
            }

            if (item.columnNumber.length < this.colsInTable && !stopMerging) {
                rows.push(this.createNewRow(rows.length));
                rows[rows.length - 1].elementsInRow.push(item);
            }
        });

        return rows;
    },
    createNewRow: function (rowNumber) {
        return {
            elementsInRow: [],
            rowNumber: rowNumber
        }
    },
    cleanRowToMerge: function (row) {
        while (row.firstChild.nextSibling) {
            row.removeChild(row.firstChild.nextSibling);
        }
    },
    showMergedObj: function (obj, row) {
        const columnWrapper = this.createMergedColumnWrapper(row);
        obj.forEach(item => this.createColumnItem(item.elementsInRow, columnWrapper));
    },
    createMergedColumnWrapper: function (row) {
        const wrapper = document.createElement('div');
        wrapper.classList.add('merged-cols__wrapper');
        row.appendChild(wrapper);
        return wrapper;
    },
    createColumnItem: function (elements, wrapper) {
        let colBody = null;
        switch (elements.length) {
            case 3:
                colBody = document.createElement('div');
                colBody.classList.add('offer-item');
                colBody.classList.add('offer-item-row');
                colBody.classList.add('offer-item--three-column-width');
                colBody.dataset.columnNumber = 0;
                this.createItemsInCol(elements, colBody);
                wrapper.appendChild(colBody);
                break;
            default:
                const filledColumn = elements[0].columnNumber;
                this.createEmptyColumns(filledColumn, wrapper, (additionalClasses) => this.createItemsInCol(elements, colBody, additionalClasses, wrapper));
                break;
        }
    },
    createItemsInCol: function (elements, col, additionalClasses, wrapper) {
        let colBody = null;
        if (!col) {
            colBody = document.createElement('div');
            colBody.classList.add('offer-item');
        }

        elements.forEach((item) => {
            if (!this.stats[item.id]) this.stats[item.id] = 0;
            (colBody || col).appendChild(item.elementHTML.cloneNode(true));

            if (additionalClasses) {
                this.setClassesToElement(colBody || col, additionalClasses);
            }
            if ((colBody || col).classList.contains('singleColumn')) {
                (colBody || col).dataset.columnNumber = item.columnNumber[this.stats[item.id]];
            }
            if ((colBody || col).classList.contains('doubleColumn')) {
                (colBody || col).dataset.columnNumber = item.columnNumber[item.columnNumber.length - 1];
            }
            if ((colBody || col).classList.contains('offer-item--three-column-width')) {
                (colBody || col).dataset.columnNumber = 0;
            }
            this.stats[item.id]++;
        });

        if (wrapper) {
            colBody ? wrapper.appendChild(colBody) : wrapper.appendChild(col);
        }
    },
    createEmptyColumns: function (filled, wrapper, createColumnWithContent) {
        const firstFilled = filled.indexOf('1') !== -1;
        const secondFilled = filled.indexOf('2') !== -1;
        const thirdFilled = filled.indexOf('3') !== -1;

        if (firstFilled && secondFilled && thirdFilled) {
            return createColumnWithContent('offer-item--three-column-width');
        }

        if (
            (firstFilled && secondFilled && !thirdFilled) ||
            (secondFilled && thirdFilled && !firstFilled)
        ) {
            return this.fillDoubleColumn(wrapper, createColumnWithContent, {
                firstFilled: firstFilled,
                thirdFilled: thirdFilled
            });
        }

        if (firstFilled && thirdFilled && !secondFilled) {
            createColumnWithContent('singleColumn');
            createColumnWithContent('singleColumn');
            return;
        }

        if (firstFilled && !secondFilled && !thirdFilled) {
            createColumnWithContent('singleColumn');
            this.createColumnElement(wrapper, ['offer-item--one-column-width', 'emptyColumn'], 2);
            this.createColumnElement(wrapper, ['offer-item--one-column-width', 'emptyColumn'], 3);
            return;
        }

        if (thirdFilled && !firstFilled && !secondFilled) {
            this.createColumnElement(wrapper, ['offer-item--one-column-width', 'emptyColumn'], 1);
            this.createColumnElement(wrapper, ['offer-item--one-column-width', 'emptyColumn'], 2);
            createColumnWithContent('singleColumn');
            return;
        }

        if (secondFilled && !firstFilled && !thirdFilled) {
            this.createColumnElement(wrapper, ['offer-item--one-column-width', 'emptyColumn'], 1);
            createColumnWithContent('singleColumn');
            this.createColumnElement(wrapper, ['offer-item--one-column-width', 'emptyColumn'], 3);
        }
    },
    findFreeSlotForSingleColumn: function (col, rows) {
        const parent = col.parentElement;
        const firstEmptyCol = rows.querySelector(`.emptyColumn[data-column-number="${col.dataset.columnNumber}"]`);

        if (firstEmptyCol) {
            parent.insertBefore(col, firstEmptyCol);
            firstEmptyCol.classList.remove('emptyColumn');
            parent.removeChild(firstEmptyCol);
        }
    },
    fillDoubleColumn: function (wrapper, createColumnWithContent, {firstFilled, thirdFilled}) {
        if (!firstFilled) this.createColumnElement(wrapper, ['offer-item--one-column-width', 'emptyColumn'], 1);
        createColumnWithContent(['offer-item--two-column-width', 'doubleColumn']);
        if (!thirdFilled) this.createColumnElement(wrapper, ['offer-item--one-column-width', 'emptyColumn'], 3);
    },
    createColumnElement: function (wrapper, additionalClass, colNum) {
        const col = document.createElement('div');
        col.classList.add('offer-item');
        this.setClassesToElement(col, additionalClass);
        if (colNum) col.dataset.columnNumber = colNum;
        if (wrapper) return wrapper.appendChild(col);
        return col;
    },
    setClassesToElement: function (element, classNames) {
        if (classNames && typeof classNames === 'string') element.classList.add(classNames);
        if (classNames && typeof classNames === 'object') {
            classNames.forEach(className => element.classList.add(className));
        }
    },
    addEmptyMissingColumns: function (row) {
        const items = row.querySelectorAll('.offer-item');
        const itemsNumber = items.length;

        const lastItem = items[itemsNumber - 1];
        const previousItem = items[itemsNumber - 2];

        if (items[itemsNumber - 3].classList.contains('offer-item--label-item')) {
            const col = this.createColumnElement(null, ['offer-item--two-column-width', 'emptyColumn']);
            lastItem.parentElement.insertBefore(col, lastItem);
        } else {
            if (previousItem.dataset.columnNumber - items[itemsNumber - 3].dataset.columnNumber === parseInt(previousItem.dataset.columnNumber)) {
                const col = this.createColumnElement(null, ['offer-item--one-column-width', 'emptyColumn']);
                previousItem.parentElement.insertBefore(col, previousItem);
            }
        }

        const diff = lastItem.dataset.columnNumber - previousItem.dataset.columnNumber;

        if (!this.setOrderInLastRow(lastItem, previousItem)) {
            return this.addEmptyMissingColumns(row);
        }

        if (!diff) {
            const col = this.createColumnElement(null, ['offer-item--two-column-width', 'emptyColumn']);
            lastItem.parentElement.insertBefore(col, lastItem);
        }

        if (diff === 1) {
            const beforePreviousItem = items[itemsNumber - 3];
            const newCol = this.createColumnElement(null, ['offer-item--one-column-width', 'emptyColumn']);
            newCol.dataset.columnNumber = 1;
            previousItem.dataset.columnNumber - beforePreviousItem.dataset.columnNumber !== 1 ?
                previousItem.parentElement.insertBefore(newCol, previousItem)
                : null;
        }

        if (lastItem.dataset.columnNumber === 1) {
            this.createColumnElement(lastItem.parentElement, ['offer-item--two-column-width', 'emptyColumn']);
        }

        if (lastItem.dataset.columnNumber === 2) {
            this.createColumnElement(lastItem.parentElement, ['offer-item--one-column-width', 'emptyColumn']);
        }
    },
    setOrderInLastRow: function (lastItem, prevLastItem) {
        if (lastItem.dataset.columnNumber < prevLastItem.dataset.columnNumber) {
            lastItem.parentElement.insertBefore(lastItem, prevLastItem);
            return false;
        }
        return true;
    }
};
